export default function collateErrors(values, props, json) {
    const { messages } = props

    if (json && json.errors) {
        const errors = {}
        json.errors.forEach(({ errorParameters, errorKey, errorMessage }) => {
            switch (errorKey) {
                default:
                    errors._error = messages.errors.generic()
            }
        })
        return errors
    }
    return { _error: messages.errors.global() }
}
